import React from 'react';

import Module from '../components/module';
import Title from '../components/title';
import PrimaryButton from '../components/primary-button';

import withDevice from '../components/withDevice';

class BarChart extends Module {
    render() {
        const {
            config,
            device: { isMobile, isTablet },
        } = this.props;
        const { title, button_text, button_url, stats } = { ...config };

        const renderStatBar = (percentage) => {
            let value = percentage;

            const OFFSET = 400; // media query breakpoint which sets fluid container width
            if (isMobile && window.innerWidth >= OFFSET) {
                const sizeDifference = (window.innerWidth - OFFSET) * 0.4;
                const sizeToAdd = sizeDifference * (percentage * 0.01);

                value = percentage + sizeToAdd;
            }

            return {
                [isMobile ? 'width' : 'height']: value,
            };
        };

        const applyStyleIfDesktop = (style) =>
            !isMobile && !isTablet
                ? `bar-chart-background-color ${style}`
                : undefined;

        return (
            <div className={applyStyleIfDesktop('-padded')}>
                <div className={applyStyleIfDesktop('-wrap')}>
                    <section className="bar-chart">
                        <div className="bar-chart__head">
                            <Title className="bar-chart__head__title" level={2}>
                                {title}
                            </Title>
                            {
                                button_text && button_url ? (
                                    <PrimaryButton
                                        className="bar-chart__head__button"
                                        type="link"
                                        title={button_text}
                                        href={button_url}>
                                        {button_text}
                                    </PrimaryButton>
                                ) : null
                            }
                        </div>
                        {stats.length > 0 && (
                            <div className="bar-chart__stats">
                                {stats.map((s, idx) => (
                                    <div
                                        className="bar-chart__stats__item"
                                        key={idx}>
                                        <div className="bar-chart__stats__item__value">
                                            <div className="bar-chart__stats__item__value__bar">
                                                <div
                                                    className="bar-chart__stats__item__value__bar__percentage__filler"
                                                    style={{
                                                        height: 100 - s.value,
                                                    }}
                                                />
                                                <div
                                                    className="bar-chart__stats__item__value__bar__percentage"
                                                    style={renderStatBar(
                                                        s.value,
                                                    )}
                                                />
                                            </div>
                                            <div className="bar-chart__stats__item__value__number">
                                                {s.value}%
                                            </div>
                                        </div>
                                        <Title
                                            level={5}
                                            className="bar-chart__stats__item__desc">
                                            {s.desc}
                                        </Title>
                                    </div>
                                ))}
                            </div>
                        )}
                    </section>
                </div>
            </div>
        );
    }
}

export default withDevice(BarChart);
